<template>
  <div>
    <PasswordConfirmationActivationModal
      v-if="actionType"
      @getProgram="changeProgram()"
      :two-factory-authentication="twoFactoryAuthentication"
      :actionType="actionType"
      @closeModal="actionType = ''"
    />
    <modalUpload @save="saveFile"> </modalUpload>
    <main class="container-fluid">
      <section class="row">
        <div class="col-2 px-3 d-none d-md-flex"></div>
        <div class="col-md-24 py-3 mb-5">
          <div class="col d-column">
            <h1 class="title pt-2 mb-0" v-text="$ml.get('programSettings')">
              Configurações do programa
            </h1>
            <h1 class="title">
              <span class="pb-2" v-text="$ml.get('dontForgetToSaveYourChanges')"
                >Não esqueça de salvar as alterações!</span
              >
            </h1>
            <div class="card mb-3">
              <div class="card-header" v-text="$ml.get('settings')">
                Configurações
              </div>
              <div class="card-body">
                <div class="d-flex flex-column w-100 mt-4">
                  <div class="card mb-4"  v-show="program.type == 'public' && program.status == 'in_progress'">
                      <table>
                        <thead>
                          <tr>
                            <th class="col-24 d-flex justify-content-between align-items-center">
                              <label style="font-weight: 500" class="pr-2" v-text="$ml.get('publishToTheWeb')">
                                Publicar na Web ?
                              </label>
                              <label class="switch">
                                <input
                                  type="checkbox"
                                  @click.prevent="exposedProgram()"
                                  :checked="program.exposed"
                                />
                                <span class="slider round"></span>
                              </label>
                            </th>
                          </tr>
                        </thead>
                        <tbody v-if="program.exposed">
                          <tr class="mb-1 p-1">
                            <td class="col-12 d-flex align-items-center">
                              <div class="form-group col" v-if="program.type != 'private'">
                                  <label v-text="$ml.get('directoryName')"
                                    >Nome do Diretório</label
                                  >
                                  <input
                                    v-mask="customSlug"
                                    maxlength="25"
                                    class="form-control col-16"
                                    v-model="slug"
                                    :placeholder="
                                      $ml.get('theNameWillBeAssignedToYourProgramsURL')
                                    "
                                  />
                                  <p class="p-1">{{ url }}/{{ slug }}</p>
                                  <transition name="fade">
                                    <label
                                      v-if="validateError && !$v.slug.minLength"
                                      class="lblError"
                                      v-text="$ml.get('requiredField')"
                                      >Campo obrigatório</label
                                    >
                                  </transition>
                                </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  <div class="row w-100 mb-4">
                  <div v-if="getUserRole === 'owner'" class="col-24">
                    <div class="card">
                      <table>
                        <thead>
                          <tr>
                            <th class="col-24 d-flex justify-content-between align-items-center">
                              <label style="font-weight: 500" class="pr-2" v-text="$ml.get('labelFeatureTwoFactorAuthenticationHacker')">
                                Apenas os especialistas com Two-Factor Authentication podem enviar novos relatórios para o programa.
                              </label>
                              <label class="switch">
                                <input
                                  type="checkbox"
                                  v-b-modal.modal-email-authentication
                                  @click.prevent="actionType = '2fa_hacker'"
                                  :checked="twoFactoryAuthentication"
                                />
                                <span class="slider round"></span>
                              </label>
                            </th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </div>
                </div>
                  <div class="row w-100" v-if="!target_settings?.active">
                    <div class="col-24">
                      <div class="card">
                        <table>
                          <thead>
                            <tr>
                              <th class="col-24">
                                <div class="row d-flex justify-content-between align-items-center">
                                  <label style="font-weight: 500" class="pr-2">
                                    {{ $ml.get("titleBudgetActive") }}
                                  </label>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="col">
                                <div class="d-flex justify-content-between align-items-center">
                                  <label style="font-weight: 500" class="pr-2">
                                    {{ $ml.get("budgetActive") }}
                                  </label>
                                  <label class="switch">
                                    <input
                                      type="checkbox"
                                      v-model="
                                        budgetRegistration.activateBudget
                                      "
                                    />
                                    <span class="slider round"></span>
                                  </label>
                                </div>
                              </td>
                            </tr>
                            <tr class="mb-1 py-1">
                              <td class="col-12 d-flex align-items-center">
                                <label>{{
                                  $ml.get("budgetLimitProgram")
                                }}</label>
                              </td>
                              <td
                                class="col-12 p-0 px-2 d-flex align-items-center"
                                style="position: relative"
                              >
                                  <label class="currency">{{currency === 'BRL' ? 'R$' : 'US$'}}</label>

                                <money
                                  class="form-control mask-real w-100"
                                  @input.native="mathAbsMoney"
                                  v-model.number="
                                    budgetRegistration.budgetValue
                                  "
                                  :placeholder="placeholderMoney"
                                  maxLength="20"
                                />
                                <transition name="fade">
                                  <label
                                    v-if="budgetMessageError.budgetValue"
                                    class="lblError p-lblError"
                                    v-text="$ml.get('errorValueBudget')"
                                  >
                                    {{ $ml.get("errorBudgetLimit") }}
                                  </label>
                                  <label
                                    v-if="budgetRegistration.budgetValue < 0"
                                    class="lblError p-lblError"
                                    v-text="$ml.get('labelCurrencyValue')"
                                  >
                                    {{ $ml.get("invalidValueBudget") }}
                                  </label>
                                </transition>
                              </td>
                            </tr>
                            <tr class="mb-1 py-1">
                              <td class="col-12 d-flex align-items-center">
                                <label>{{
                                  $ml.get("notificationBudget")
                                }}</label>
                              </td>
                              <td class="col-12 p-0 py-1 px-2">
                                <input
                                  class="form-control"
                                  v-mask="['#%', '##%']" 
                                  type="text"
                                  v-model.number="budgetRegistration.notification"
                                  placeholder="70%"
                                  maxlength="3"
                                  @input="adjustCursor"
                                />
                                <div class="col-24">
                                  <transition name="fade">
                                    <label
                                      v-if="budgetMessageError.notification"
                                      class="lblError"
                                      v-text="
                                        $ml.get('errorBudgetNotification')
                                      "
                                    >
                                      {{ $ml.get("percentageBudget") }}
                                    </label>
                                    <label
                                      v-if="
                                        budgetRegistration.notification < 0 ||
                                        budgetRegistration.notification > 100
                                      "
                                      class="lblError p-lblError"
                                      v-text="$ml.get('labelInvalidValue')"
                                    >
                                      > {{ $ml.get("percentageErrorBudget") }}
                                    </label>
                                  </transition>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td class="col-12 d-flex align-items-center">
                                <label>
                                  {{ $ml.get("pauseProgramBudget") }}</label
                                >
                              </td>
                              <td
                                class="col-12 py-2 p-0 px-2 d-flex align-items-center"
                              >
                                <label class="switch">
                                  <input
                                    type="checkbox"
                                    v-model="budgetRegistration.pauseProgram"
                                  />
                                  <span class="slider round"></span>
                                </label>
                              </td>
                            </tr>
                            <tr
                              class="py-1"
                              v-show="budgetRegistration.pauseProgram"
                            >
                              <td class="col-12 d-flex align-items-center">
                                <label
                                  >{{
                                    $ml.get("percentagePauseBudget")
                                  }}:</label
                                >
                              </td>
                              <td class="col-12 py-2 p-0 px-2">
                                <input
                                  class="px-2 form-control"
                                  v-mask="['#%', '##%']"
                                  type="text"
                                  v-model.number="
                                    budgetRegistration.breakPercentage
                                  "
                                  placeholder="90%"
                                  maxlength="3"
                                  @input="adjustCursor"
                                />
                                <div class="col-24">
                                  <transition name="fade">
                                    <label
                                      v-if="budgetMessageError.breakPercentage"
                                      class="lblError"
                                      v-text="
                                        $ml.get('errorBudgetNotification')
                                      "
                                    >
                                      Informe o percentual desejado
                                    </label>
                                    <label
                                      v-if="
                                        budgetRegistration.breakPercentage <
                                          0 ||
                                        budgetRegistration.breakPercentage > 100
                                      "
                                      class="lblError p-lblError"
                                      v-text="$ml.get('labelInvalidValue')"
                                    >
                                      {{ $ml.get("percentageErrorBudget") }}
                                    </label>
                                  </transition>
                                </div>
                              </td>                           
                            </tr>
                            <tr>
                              <td class="col d-flex justify-content-end py-0" style="margin-bottom: 5px;">
                                <div
                                  class="d-flex w-100 align-items-center mt-5 justify-content-end"
                                >
                                  <div
                                    class="d-flex flex-row justify-content-end align-items-start w-100"
                                  >
                                    <a
                                      @click="validateForm()"
                                      class="btn"
                                      v-text="$ml.get('saveEditions')"
                                      >Salvar alterações</a
                                    >
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>                        
                        </table>                    
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-4">
                  <label v-text="$ml.get('managersWithAccesToTheProgram')"
                    >Gestores com acesso ao programa</label
                  >
                  <div class="card card-body p-0 d-flex w-100">
                    <table>
                      <thead>
                        <tr>
                          <th class="col-11 text-truncate">E-mail</th>
                          <th
                            class="col-9 pl-0 text-truncate"
                            v-text="$ml.get('permission')"
                          >
                            Permissão
                          </th>
                          <th
                            class="col-3 pl-0 text-truncate"
                            v-text="$ml.get('freeAccess')"
                          >
                            Acesso liberado
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-show="loading_table" class="loading">
                          <div class="c-loader m-3"></div>
                        </tr>
                        <div v-if="!loading_table">
                          <tr
                            v-if="!listCompany_members.length"
                            class="d-flex align-items-center justify-content-center"
                          >
                            <h6
                              class="my-3"
                              v-text="$ml.get('noUserAvailable')"
                            >
                              Nenhum usuário disponível
                            </h6>
                          </tr>
                          <div
                            v-for="item in listCompany_members"
                            :key="item._id + 'role'"
                          >
                            <tr
                              v-if="
                                item.status == 'active' && item.role == 'owner'
                              "
                            >
                              <td class="col-11">
                                <strong v-text="item.email"></strong>
                              </td>
                              <td
                                class="col-9 pl-0 text-muted"
                                v-text="$ml.get('primaryEmail')"
                              >
                                E-mail principal
                              </td>
                              <td class="col-3 pl-0">
                                <VueCustomTooltip
                                  :label="$ml.get('awaitingAcceptance')"
                                >
                                  <svg width="16" height="16" class="mb-1">
                                    <image
                                      xlink:href="../../../assets/icons/check.svg"
                                      width="16"
                                      height="16"
                                    />
                                  </svg>
                                </VueCustomTooltip>
                              </td>
                            </tr>
                          </div>
                          <div
                            v-for="item in listCompany_members"
                            :key="item._id + 'members'"
                          >
                            <tr
                              v-if="
                                item.status === 'active' && item.role != 'owner'
                              "
                            >
                              <td class="col-11">
                                <strong v-text="item.email"></strong>
                              </td>
                              <td
                                class="col-9 pl-0 text-muted text-capitalize"
                                v-text="$ml.get('v_' + item.role)"
                              ></td>
                              <td class="col-2 pl-0">
                                <label class="switch mb-0">
                                  <input
                                    :checked="item.join_program"
                                    type="checkbox"
                                    
                                    @click.prevent="saveProgram(item._id)"
                                  />
                                  <span class="slider round"></span>
                                </label>
                              </td>
                            </tr>
                          </div>
                        </div>
                      </tbody>
                    </table>
                  </div>
                </div>
               
                
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>
<script>
import $ from "jquery";
import Swal from "sweetalert2";
import { minLength, required } from "vuelidate/lib/validators";
import modalUpload from "../../../components/modalUpload.vue";
import CompanyService from "../../../services/company.service";
import ProgramService from "../../../services/program.service";
import PasswordConfirmationActivationModal from "../../modais/PasswordConfirmationActivationModal.vue";
import { utils } from "../../../utils";

const regexOTN = utils.regexCheck("OTN");
export default {
  name: "configProgram",
  props: ["program", "id", "managers"],
  components: {
    modalUpload,
    PasswordConfirmationActivationModal,
  },
  data() {
    return {
      avatar: require("../../../assets/images/empty.png"),
      file: null,
      name: "",
      description: "",
      slug: "",
      typeProgram: "public",
      validateError: false,
      loading: false,
      selectedManagers: [],
      listCompany_members: [],
      loading_table: true,
      selectedUsers: [],
      errorSlug: false,

      customSlug: {
        mask: "CCCCCCCCCCCCCCCCCCCCCCCCC",
        tokens: {
          C: {
            pattern: /[0-9a-zA-Z-]/,
            transform: function (v) {
              return v.toLocaleLowerCase();
            },
          },
        },
      },
      url: window.location.origin,

      budgetRegistration: {
        activateBudget: false,
        pauseProgram: false,
        notification: "",
        budgetValue: 0,
        breakPercentage: null,
      },
      budgetMessageError: {
        budgetValue: "",
        notification: "",
        breakPercentage: "",
      },
      twoFactoryAuthentication: false,
      actionType:"",
      getUserRole: "",
      target_settings: [],
      currency:"",
    };
  },
  validations: {
    name: { required, regexOTN, minLength: minLength(3) },
    description: { required, minLength: minLength(3) },
    slug: { minLength: minLength(2) },
  },
  watch: {
    budgetRegistration: {
      handler() {
        const { budgetValue, notification, pauseProgram } =
          this.budgetRegistration;
        if (budgetValue && this.budgetMessageError.budgetValue)
          return (this.budgetMessageError.budgetValue = false);
        if (notification && this.budgetMessageError.notification)
          return (this.budgetMessageError.notification = false);
        if (pauseProgram && this.budgetMessageError.breakPercentage)
          return (this.budgetMessageError.breakPercentage = false);
      },
      deep: true,
    },
  },
  mounted(){
    this.currency = this.$store.getters['getUser'].currency;
    this.getUserRole = this.$store.getters["getUserRole"];
  },
  computed:{
    placeholderMoney(){
        return this.currency === 'BRL' ? 'R$ 0,00' : '$ 0,00'
    }
  },
  methods: {
    adjustCursor(event) {
      const input = event.target;
      const length = input.value.length;

      if (input.value.includes('%')) {
        input.setSelectionRange(length - 1, length - 1);
      }
    },

    mathAbsMoney() {
      this.spendingBudget = Math.abs(this.spendingBudget);
    },

    addProgram(id) {
      let filterList = this.listCompany_members.map((it) => {
        if (it._id === id) {
          it.join_program = !it.join_program;
        }
        return it;
      });
      this.listCompany_members = filterList;

      this.selectedUsers = this.listCompany_members?.filter(
        (it) => it?.join_program === true,
      );
      this.selectedMembers(this.selectedUsers);
    },

    formartObj(data) {
      return data.map((i) => ({ ...i, join_program: false }));
    },

    changeMembers() {
      this.loading_table = true;

      CompanyService.getMembers().then(
        (response) => {
          this.loading_table = false;
          this.listCompany_members = this.formartObj(
            response.data.company_members,
          );
          let filterManagers = this.managers?.map((it) => it._id);
          this.selectedManagers = filterManagers ?? [];
          this.listCompany_members = this.listCompany_members.map((it) => {
            if (filterManagers.includes(it._id)) {
              it.join_program = !it.join_program;
            }
            return it;
          });
        },
        () => {
          this.loading_table = false;
        },
      );
    },
    selectedMembers(data) {
      let filterManagersId = data?.map((it) => it?._id);
      this.selectedManagers = filterManagersId ?? [];
    },

    validateForm() {
      this.loading = true;
      let self = this;

      if (this.budgetRegistration?.activateBudget) {
        const { budgetValue, notification, pauseProgram, breakPercentage } =
          this.budgetRegistration;
        if (budgetValue < 0) return;
        if (notification < 0 || notification > 100 || isNaN(notification))
          return;
        if (
          breakPercentage < 0 ||
          breakPercentage > 100 ||
          isNaN(breakPercentage)
        )
          return;
        if (!budgetValue) return (this.budgetMessageError.budgetValue = true);
        if (!notification) return (this.budgetMessageError.notification = true);
        if (pauseProgram && !breakPercentage)
          return (this.budgetMessageError.breakPercentage = true);
      }

      this.$v.$touch();

      if (
        this.$v.name.$error ||
        this.$v.description.$error ||
        this.$v.slug.$error
      ) {
        this.validateError = true;
        this.loading = false;
        Swal.fire({
          icon: "info",
          title: "",
          text: self.$ml.get("fillInAllFieldHighlightedInRed"),
        });
        $("html, body").animate({ scrollTop: 0 }, "5000");
        return;
      }

      this.validateError = false;
      this.saveProgram();
    },

    saveFile(file) {
      this.file = file.file;
      this.avatar = file.src;
    },
    exposedProgram() {
      this.$emit("exposedProgram");
    },
    changeProgram() {
      ProgramService.getProgramDetail(this.id).then(
        (response) => {
          $("html, body").animate({ scrollTop: 0 }, "5000");
          let file = response.data.avatar;
          var img = document.createElement("img");
          img.src = file;
          var self = this;
          img.onload = function () {
            self.avatar = file;
          };
          this.name = response?.data?.name;
          this.description =
            !response.data.description ||
            response.data.description == `undefined` ||
            response.data.description == undefined
              ? ""
              : response.data.description;
          this.slug = response?.data?.slug;
          this.typeProgram = response?.data?.type;

          const {
            active,
            pause_program,
            percentage_alert,
            max_value,
            percentage_pause,
          } = response?.data?.settings?.budget;
          this.budgetRegistration.activateBudget = active ?? false;
          this.budgetRegistration.pauseProgram = pause_program ?? false;
          this.budgetRegistration.notification = percentage_alert === 0 ? "" : percentage_alert 
          this.budgetRegistration.budgetValue = max_value ?? 0;
          this.budgetRegistration.breakPercentage = percentage_pause === 0 ? "" : percentage_pause 

          this.target_settings = response.data?.target_settings

          const { twoFactorAuthentication } = response?.data?.settings;
          this.twoFactoryAuthentication = twoFactorAuthentication ?? false;
        },
        () => {
          this.$router.push("/program");
        },
      );
    },
    saveProgram(idUser) {
      var self = this;
      const budgetObj = {
        budget: {
          active: this.budgetRegistration?.activateBudget,
          max_value: this.budgetRegistration?.budgetValue,
          percentage_alert:
            this.budgetRegistration?.notification === null
              ? ""
              : this.budgetRegistration?.notification,
          pause_program: this.budgetRegistration?.pauseProgram,
          percentage_pause:
            this.budgetRegistration?.breakPercentage === null
              ? 0
              : this.budgetRegistration?.breakPercentage,
        },
        // twoFactorAuthentication: this.twoFactoryAuthentication,
      };
      const formData = new FormData();

      if(this.target_settings?.active){
        formData.append("target_settings", JSON.stringify(this.target_settings));
      }

      if (this.file) {
        formData.append("file", this.file);
      }
      formData.append("name", this.name);
      formData.append("description", this.description);
      formData.append("settings", JSON.stringify(budgetObj));

      if(idUser === undefined || !idUser){
        if (this.selectedManagers) {
        formData.append("managers", JSON.stringify(this.selectedManagers));
      }
      }

      if (this.slug) {
        formData.append("slug", this.slug);
      }
      Swal.fire({
        title: self.$ml.get("AreYouSureYouWantToCompleteTheRequest"),
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#730ba9",
        customClass: {
          cancelButton: "btn-outline-extra",
        },
        confirmButtonText: self.$ml.get("conclude"),
        cancelButtonText: self.$ml.get("cancel"),
      }).then((result) => {
        if (result.value) {
          if(idUser){
            this.addProgram(idUser);
            if (this.selectedManagers) {
            formData.append("managers", JSON.stringify(this.selectedManagers));
           }
          }
          ProgramService.putProgram(formData, this.id).then(
            () => {
              this.changeProgram();
              self.loading = false;
              Swal.fire({
                icon: "success",
                title: self.$ml.get("programSuccessfullyChanged"),
                showConfirmButton: false,
                timer: 2000,
              });
            },
            (error) => {
              self.loading = false;
              const splitMessage = error.response?.data?.message?.split("_");
              const errorType =
                splitMessage[1] + splitMessage[2] + splitMessage[3];
              if (errorType === "scopelimitexceeded") {
                Swal.fire({
                  icon: "info",
                  title: "",
                  text: self.$ml.get("scopeLimitExceeded"),
                });
              } else if (
                error.response.data.message ==
                "Já existe um programa cadastrado com essa slug!"
              ) {
                Swal.fire({
                  icon: "info",
                  title: "",
                  text: self.$ml.get("thereIsAlreadyProgramSlug"),
                });
              } else if (
                error.response.data.message ==
                "Já existe um programa cadastrado com esse nome!"
              ) {
                Swal.fire({
                  icon: "info",
                  title: "",
                  text: self.$ml.get("thereIsAlreadyAprogram"),
                });
              } else {
                Swal.fire({
                  icon: "info",
                  title: "",
                  text: self.$ml.get("unableToCompleteThisRequest"),
                });
              }
            },
          );
        } else {
          self.loading = false;
        }
      });
    },
  },
  created() {
    this.changeMembers();
    this.changeProgram();
  },
};
</script>
<style scoped>
.avatar-wrapper {
  height: 85px;
  width: 85px;
}

body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown),
html.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {
  height: 100% !important;
  overflow-y: visible !important;
}
.primary-text {
  color: #730ba9 !important;
}

.modal-textarea {
  height: 50vh;
}
.currency {
  position: absolute;
  left: 2%;
  top: 52.5%;
  transform: translate(50%, -52%);
  font-weight: 400;
  color: #495057;
}
.input-custom {
  border: none;
  border-bottom: 1px solid #ccc;
  border-radius: 0px;
  width: 150px;
  height: 15px;
}
.p-lblError {
  position: absolute;
  top: 82%;
}
.desc-two-factory {
  font-size: 1rem;
}
.desc-two-factory span {
  font-weight: 500;
}
</style>
